module.exports = {
    CHAM_CAROUSEL_OBSERVER_B: 2611,
    GIG_PAGE_V5_EXPERIMENT: 3119,
    CHAM_GROWTH_CAROUSEL_EXTERNAL_VISITS: 3157,
    OWLS_CHOICE_PRICE_MODALITIES_AUTOMATION_EXP: 3164,
    PORTFOLIO_PRESENCE_ABTEST: 3232,
    FOXES_CREATE_BRIEF: 3253,
    QUAL_REVIEWS_WORK_SAMPLE_MOBILE: 3255,
    QUALAS_GIG_RATING_PROJECT_1: 3273,
    LIONS_PROMOTE_LOCAL_SITES: 3300,
    QUALAS_REVIEWS_BUSINESS_FILTER_AND_INDICATION: 3310,
    GIG_PAGE_LAYOUT_EXPERIMENT: 3311,
    LIONS_FINAL_PRICE_UPFRONT: 3314,
    GOATS_GIG_PAGE_STICKY_CTA: 3317,
    QUALAS_REVIEWS_SBSS_INDICATION: 3333
};
